

















































import Vue, { PropType } from 'vue'
import _ from 'lodash'
import {
  Discount,
  DiscountConstraintType,
  DiscountTriggerAction,
  Product,
  SalesProduct,
} from '@/types/generated/graphql'
import XCard from '@/components/atoms/Card/XCard.vue'
import XQuantityInput from '@/components/atoms/Input/XQuantityInput.vue'

export type Input = {
  productId: string
  quantity: number
}

type Props = {
  salesProduct: SalesProduct
  value: Input[]
  discount: Discount | null
}

type Computed = {
  product: Product
  currentValue: Input
  available: boolean
  quantity: number
  initialOrderASDiscounted: boolean
  maxItemQuantity: number | null | undefined
}

type Methods = {
  updateValue: (value: Input) => void
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: 'Product',
  components: { XCard, XQuantityInput },
  props: {
    salesProduct: {
      type: Object,
      required: true,
    },
    value: {
      type: Array, // v-modelの配列対応（checkboxの形式と同様）
      default: () => [],
    },
    discount: {
      type: Object as PropType<Discount>,
    },
  },
  computed: {
    product() {
      return this.salesProduct.product
    },
    currentValue() {
      const { productId } = this.product
      return (
        this.value.find((v) => v.productId === productId) || {
          productId,
          quantity: 0,
        }
      )
    },
    available() {
      return (
        this.salesProduct.available &&
        this.salesProduct.availableQuantity >= this.quantity
      )
    },
    quantity: {
      get() {
        return this.currentValue.quantity
      },
      set(quantity) {
        const { productId } = this.product
        const value = { productId, quantity }
        this.updateValue(value)
      },
    },
    initialOrderASDiscounted() {
      if (!this.discount) {
        return false
      }

      if (this.discount.actionKey !== DiscountTriggerAction.InitialOrderAs) {
        return false
      }

      const productConstraint = this.discount.constraints.find(
        (constraint) => constraint.type === DiscountConstraintType.Product
      )
      if (productConstraint) {
        return (this.discount.isAvailable &&
          productConstraint.productIds &&
          productConstraint.productIds?.includes(
            this.product.productId
          )) as boolean
      }

      return this.discount.isAvailable
    },
    maxItemQuantity() {
      const constraint = this.discount?.constraints.find(
        (constraint) =>
          constraint.type === DiscountConstraintType.MaxItemQuantity
      )
      return constraint?.maxItemQuantity
    },
  },
  methods: {
    updateValue(value) {
      const input = _.unionBy([value], this.value, 'productId').filter(
        (value) => value.quantity
      )
      this.$emit('input', input)
    },
  },
})
